import React from 'react';

export default function OurTeamProfilePhoto(props) {
    const { preview, profile } = props;

    return (
        <div className="profile-photo-container bitof-margin--bottom">
            <div className="loader" />
            <div
                className={`profile-photo${preview ? ' preview' : ''} ${profile}`}
            />
        </div>
    )
}
